import { useQuery } from "@tanstack/react-query";
import { ReferralApi } from "../api/referral-api";

type UseReferralOverviewQueryOptions = {
  teamExternalId: string | undefined;
};

export function useReferralOverviewQuery({
  teamExternalId,
}: UseReferralOverviewQueryOptions) {
  return useQuery({
    queryKey: referralQueryKeys.getReferralOverview(teamExternalId ?? ""),
    queryFn: () => ReferralApi.getReferralOverview(teamExternalId ?? ""),
    meta: {
      errorMessage: "Failed to fetch referrals",
    },
    enabled: !!teamExternalId,
  });
}

const referralQueryKeys = {
  getReferralOverview: (teamExternalId: string) => [
    "referral",
    "overview",
    { teamExternalId },
  ],
};
